import { AppContainer } from "@/components/layout/app-container";
import { CartaoIdentificacaoProjeto } from "../components/cartao-identificacao-projeto";
import { TabelaLancamentos } from "../components/tabela-lancamentos";
import { useRelacaoPagamentos } from "../hooks/use-relacao-pagamentos";
import { SecaoObservacoes } from "../components/secao-observacoes";

export function RelacaoPagamentosList() {
  const {
    projetoSelecionado,
    payments,
    isLoading,
    navigate
  } = useRelacaoPagamentos()

  return (
    <AppContainer
      title={"Relação de Pagamentos"}
      description="Agência Nacional do Cinema - Superintendência de Prestação de Contas"
    >
      <div className="space-y-4 pb-4 max-h-screen">
        <div className="mt-1.5">
          <CartaoIdentificacaoProjeto projeto={projetoSelecionado ?? null} />
        </div>

        <TabelaLancamentos
          data={payments}
          onView={() => {}}
          onEdit={() => {}}
          onDelete={() => {}}
          navigate={navigate}
          isLoading={isLoading}
        />

        <SecaoObservacoes />
      </div>
    </AppContainer>
  )
}